import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { combineLatest } from 'rxjs';
import { TransportOrderView } from '../../../models/transport-order-view.model';
import { CurrentDataService } from '../../../services/current-data-service';
import { MailTransporterConfigurationService } from '../../../services/mails-transporter-configuration.service';

@Component({
  selector: 'jhi-my-transport',
  templateUrl: './my-transport.component.html',
  styleUrls: ['./my-transport.component.scss'],
})
export class MyTransportComponent implements OnInit {
  public transportOrder!: TransportOrderView;
  public savMail: string | undefined;

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected currentDataService: CurrentDataService,
    protected transporterMailService: MailTransporterConfigurationService,
    protected translateService: TranslateService
  ) {}

  public ngOnInit(): void {
    combineLatest([this.activatedRoute.data, this.transporterMailService.retrieveConfiguration()]).subscribe({
      next: (result): void => {
        this.transportOrder = result[0]['transportOrder'];
        if (
          !!(result[1] as any).mailConfig &&
          !!(result[1] as any).mailConfig.body &&
          (result[1] as any).mailConfig.body.afterSaleService?.active &&
          (result[1] as any).mailConfig.body.afterSaleService.value !== ''
        ) {
          this.savMail = (result[1] as any).mailConfig.body.afterSaleService.value;
        }
      },
    });
  }

  public callSAV(): void {
    const subject = this.translateService.instant('baryApp.myTransport.sav.subject', { transportOrderId: this.transportOrder.id });
    window!.top!.location.href = 'mailto:' + this.savMail + '?subject=' + subject;
  }

  public previousState(): void {
    window.history.back();
  }
}
